// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AccountGetUsersGetUsersContactInfoResponseModel } from './accountGetUsersGetUsersContactInfoResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AccountGetUsersGetUsersResponseModel {
    'userId': number;
    'userName': string;
    'firstName': string;
    'lastName': string;
    'phone': AccountGetUsersGetUsersContactInfoResponseModel | null;
    'fax': AccountGetUsersGetUsersContactInfoResponseModel | null;
    'email': AccountGetUsersGetUsersContactInfoResponseModel | null;
    'role': string;
    'active': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AccountGetUsersGetUsersResponseModel>> = [
        {
            "name":     "userId",
            "baseName": "userId",
            "type":     "number"
        },
        {
            "name":     "userName",
            "baseName": "userName",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "AccountGetUsersGetUsersContactInfoResponseModel"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "AccountGetUsersGetUsersContactInfoResponseModel"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "AccountGetUsersGetUsersContactInfoResponseModel"
        },
        {
            "name":     "role",
            "baseName": "role",
            "type":     "string"
        },
        {
            "name":     "active",
            "baseName": "active",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return AccountGetUsersGetUsersResponseModel.attributeTypeMap;
    }
}
